'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement } from 'react';
import { getAction } from '../graphql/utils';
import { gql, useQuery } from '@apollo/client';
export const Query = ({ doc, variables = {}, component: Component, componentProps = {}, children, getData = (data) => data, cache = 'no-cache' }) => {
    const { loading, data, error } = useQuery(gql(doc), {
        variables,
        fetchPolicy: cache
    });
    const action = getAction(doc);
    const response = data ? getData(data[action]) : data;
    if (children) {
        return Children.map(children, (child) => {
            return cloneElement(child, { ...componentProps, loading, error, ...response });
        });
    }
    return _jsx(Component, { ...componentProps, loading: loading, error: error, ...response });
};
